import { QuestionMarkedFill } from '@/components/features/quiz/question/question-marked';
import { QuestionBase } from '@/components/features/quiz/question/question-resolver';
import { useQuestionFill } from '@/hooks/questions';

import type { QuestionFillProps } from '.';

import { GapContentItem } from '.';

export function QuestionFill(questionFillProps: QuestionFillProps) {
  const { question, showMarked } = questionFillProps;
  const { marked, gaps, onGapValueChange, getMarkedState, exportedUserAnswer } = useQuestionFill(questionFillProps);

  return (
    <QuestionBase content={question.content} type={question.type}>
      <div className="text-text-secondary flex flex-wrap items-center gap-2">
        {gaps.map((gapContent, index) => (
          <GapContentItem
            key={index}
            content={gapContent.content}
            gap={gapContent.gap}
            value={gapContent.value}
            onGapValueChange={onGapValueChange}
            correct={getMarkedState(gapContent.gap)}
            showMarked={showMarked}
          />
        ))}
      </div>
      <QuestionMarkedFill marked={marked} question={question} answer={exportedUserAnswer} showMarked={showMarked} showQuestion={false} />
    </QuestionBase>
  );
}
